/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import Actions from "./../../fluid/Actions/ActionFactory";
import ErrorMessageAlert from "../Utilities/ErrorMessageAlert";
import { isValidURL, containsIpAddress } from "./../Utilities/validate";
import isValidPath from "is-valid-path";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";

export default function EditDataRenderingService({
  open,
  serverInfo,
  updateRowData,
  handleClose,
}) {
  const [name, setName] = useState(serverInfo.name);

  const [serverURL, setServerURL] = React.useState(serverInfo.url);
  const [serverURLError, setServerURLError] = React.useState(false);
  const [serverURLHelperText, setServerURLHelperText] = React.useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [errorOpen, setErrorOpen] = React.useState(false);
  const [errorInfo, setErrorInfo] = useState({});
  const nameMaxLength = 256;

  useEffect(() => {
    setServerURL(serverInfo.url);
    setName(serverInfo.name);
  }, [serverInfo, updateRowData]);

  const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
    },
    text_field_root: {
      display: "block",
      width: "60%",
    },
  }));

  const clearFields = () => {
    setName("");

    setServerURL("");
    setServerURLError(false);
    setServerURLHelperText("");

    setErrorInfo({});

    setIsLoading(false);
  };

  const handleCancel = () => {
    clearFields();
    handleClose({ refreshList: false });
  };

  const handleSubmit = () => {
    // //check if server url field contains any IP address in it.
    // if (containsIpAddress(serverURL)) {
    //   setServerURLError(true);
    //   setServerURLHelperText(
    //     "Server URL cannot contain IP address, Please use a hostname instead."
    //   );
    //   return;
    // }
    //check for valid URL.
    if (!isValidURL(serverURL)) {
      setServerURLError(true);
      setServerURLHelperText("Please enter a valid URL.");
      return;
    }
    setServerURLError(false);
    setServerURLHelperText("");

    setIsLoading(true);
    //edit world view server
    Actions("http_request", {
      url: `/sainapse/data_rendering_service/${serverInfo["name"]}`,
      method: "put",
      data: {
        name: name,
        url: serverURL,
      },
    })
      .then((response) => {
        let updatedDRLInfo = response.data.result;
        setIsLoading(false);
        updateRowData(updatedDRLInfo);
      })
      .catch((err) => {
        setIsLoading(false);
        setErrorOpen(true);
        setErrorInfo(err);
        // alert("WV server updating failed!");
      });
  };

  const classes = useStyles();

  const handleErrorClose = () => {
    setErrorOpen(false);
    setErrorInfo("");
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      id="edit-data-rendering-device"
      maxWidth="xl"
    >
      <Backdrop className={classes.backdrop} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <DialogTitle id="form-dialog-title">
        Edit Data Rendering Device
      </DialogTitle>
      <DialogContent style={{ width: "60vw" }}>
        <DialogContentText>
          To Edit a Data Rendering Device,please modify the following fields.
        </DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          disabled={true}
          id="world-view-server-name"
          label="Server Name"
          type="text"
          value={name}
          fullWidth={true}
          onChange={(event) => {
            setName(
              event.target.value.substring(
                0,
                Math.min(event.target.value.length, nameMaxLength)
              )
            );
          }}
          classes={{
            root: classes.text_field_root,
          }}
        />
        <TextField
          margin="dense"
          id="world-view-server-url"
          label="Server URL"
          error={serverURLError}
          type="url"
          value={serverURL}
          fullWidth={true}
          onChange={(event) => setServerURL(event.target.value)}
          classes={{
            root: classes.text_field_root,
          }}
          helperText={serverURLHelperText}
        />
      </DialogContent>
      <ErrorMessageAlert
        open={errorOpen}
        handleClose={handleErrorClose}
        errorInfo={errorInfo}
      ></ErrorMessageAlert>
      <DialogActions>
        <Button onClick={handleCancel} color="primary" variant="contained">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary" variant="contained">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
}
